export const CURRENT_USER = Symbol('CURRENT_USER');

export const currentUserAction = (currentUser) => ({
  type: CURRENT_USER,
  payload: {
    currentUser,
  },
});
